import React, { useState, useRef, useEffect, useReducer } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actionDispacher } from './IAAgentModule'
import { Button, Tooltip } from 'antd'
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons'

import './IAAgent.less'


interface RateResponseProps {
    tenant: string
    session: string
    item?: number
    userLogin: string
    display: boolean
}



const RateResponse: React.FC<RateResponseProps> = (props: RateResponseProps) => {
    const { tenant, session, item, userLogin } = props
    const [display, setDisplay] = useState(props.display)
    const [statusColor, setStatusColor] = useState<number | undefined>(undefined)
    const [rateResponse, setRateResponse] = useState<number | undefined>(undefined)
    const [rateComment, setRateComment] = useState<string | undefined>(undefined)

    //const dispatcher = actionDispacher()
    const dispatcherRef = useRef(actionDispacher());

    //test
    //const [, forceRerender] = useReducer(x => x + 1, 0)

    const { waitingFeedback, feedback } = useSelector(
        (state: { iaAgent: { waitingFeedback: boolean, feedback: any } }) => state.iaAgent || { waitingFeedback: false, feedback: null, session: '' }
    )

    const handleSendFeedbackNeg = () => {
        //console.log(`sending negative feedback for session ${session} and item ${item}`)
        dispatcherRef.current.sendFeedback({
            tenant: tenant,
            session: session,
            item: item,
            userLogin: userLogin,
            rating: rateResponse,
            comment: rateComment
        })

        setRateResponse(undefined)
        setRateComment(undefined)
        setStatusColor(0)
    }

    const handleSendFeedbackPos = () => {
        //console.log(`sending positive feedback for session ${session} and item ${item}`)
        dispatcherRef.current.sendFeedback({
            tenant: tenant,
            session: session,
            item: item,
            userLogin: userLogin,
            rating: 10,
            comment: ''
        })
        setRateResponse(undefined)
        setRateComment(undefined)
        setStatusColor(1)
    }

    if (display === false) {
        return <></>
    }

    return (
        <div className='rate-response'>
            <div className='rate-response-buttons'>
                <Tooltip placement="top" title={'Buena respuesta'}>
                    <Button
                        type="primary"
                        className={`rate-button-${statusColor === 1 ? 'green' : 'blue'}`}
                        disabled={statusColor !== undefined}
                        icon={<LikeOutlined />}
                        onClick={() => handleSendFeedbackPos()}
                    />
                </Tooltip>
                <Tooltip placement="top" title={'Respuesta deficiente'}>
                    <Button
                        type="primary"
                        className={`rate-button-${statusColor === 0 ? 'red' : 'blue'}`}
                        disabled={statusColor !== undefined}
                        icon={<DislikeOutlined />}
                        onClick={() => setRateResponse(0)}
                    />
                </Tooltip>
            </div>
            {
                rateResponse === 0
                && <div className='rate-response-comment'>
                    <textarea
                        rows={1}
                        placeholder="dejanos tu comentario..."
                        value={rateComment}
                        onChange={(e) => setRateComment(e.target.value)}
                        className="rate-response-textarea"
                    />
                    <button onClick={handleSendFeedbackNeg} className='chat-button'>
                        Enviar
                    </button>
                </div>
            }

        </div>
    )
}

export default RateResponse
